<kion-image-carousel
  [items]="items"
  [groupSize]="1"
  [activeSlide]="activeSlide"
  (update)="updated($event)"
></kion-image-carousel>
